"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.completeMany = exports.completeOne = exports.uploadFiles = exports.uploadFile = void 0;
var manager_1 = require("./manager");
var uploadFile = function (config) {
    return function (file, callbacks, ctx) {
        if (callbacks === void 0) { callbacks = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, cancelAll, uploads, promise;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, exports.uploadFiles)(config)([file], callbacks, ctx)];
                    case 1:
                        _a = _b.sent(), cancelAll = _a.cancelAll, uploads = _a.uploads, promise = _a.promise;
                        return [2 /*return*/, {
                                cancel: cancelAll,
                                upload: uploads[0],
                                promise: promise.then(function (uploadedFiles) { return uploadedFiles[0]; }),
                                uploadType: config.uploadType,
                            }];
                }
            });
        });
    };
};
exports.uploadFile = uploadFile;
var uploadFiles = function (_a) {
    var uploadType = _a.uploadType, maxConcurrentUploads = _a.maxConcurrentUploads, initiate = _a.initiate, getPartRequest = _a.getPartRequest;
    return function (files, callbacks, ctx) {
        if (callbacks === void 0) { callbacks = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var uploads, manager, cancellableUploads;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, initiate(files, ctx)];
                    case 1:
                        uploads = (_a.sent()).map(function (initiatedUpload, idx) { return (__assign(__assign({}, initiatedUpload), { file: files[idx] })); });
                        manager = new manager_1.UploadManager({
                            onProgress: callbacks.onProgress,
                            onError: callbacks.onError,
                            onComplete: callbacks.onComplete,
                            onUploadComplete: callbacks.onUploadComplete,
                            uploads: uploads,
                            maxConcurrent: maxConcurrentUploads,
                            getPartRequest: getPartRequest,
                        });
                        return [4 /*yield*/, manager.start()];
                    case 2:
                        cancellableUploads = _a.sent();
                        return [2 /*return*/, {
                                cancelAll: function () { return manager.cancel(); },
                                uploadType: uploadType,
                                uploads: cancellableUploads,
                                // This promise will be resolved when all chunks are uploaded
                                // and rejected when an error occurs during the upload process and the 'CANCEL_ALL' strategie is adopted or when the upload is aborted
                                // This promise will be returned as pending to allow the caller to abort the upload or to wait for completion
                                promise: manager.promise(),
                            }];
                }
            });
        });
    };
};
exports.uploadFiles = uploadFiles;
var completeOne = function (config) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (file, ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var s3Object;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, exports.completeMany)(config)([file], ctx)];
                case 1:
                    s3Object = (_a.sent())[0];
                    return [2 /*return*/, s3Object];
            }
        });
    }); };
};
exports.completeOne = completeOne;
var completeMany = function (config) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (files, ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var s3Objects;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, config.complete(files, ctx)];
                case 1:
                    s3Objects = _a.sent();
                    return [2 /*return*/, s3Objects];
            }
        });
    }); };
};
exports.completeMany = completeMany;
